import moment from 'moment';
import i18n from 'i18n-js';

const DEFAULT_CURRENCY = {
  'en-us': 'USD',
  'en-ca': 'CAD',
  'en-nz': 'NZD',
  'es-mx': 'MXN',
  'en-au': 'AUD',
};

const CHART_COLORS = ['#49457B', '#FF7C78'];

const tooltipFormatter = ({ item, format, locale }) => {
  // Transform from (LCID) python to rfc5646
  const formattedLocale = locale?.replace('_', '-').toLowerCase();
  const currency = DEFAULT_CURRENCY[formattedLocale] || 'USD';
  switch (format) {
    case 'currency':
      if (isNaN(item)) {
        return item;
      } else {
        const val = new Intl.NumberFormat(formattedLocale, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(item);
        return `${val} ${currency}`;
      }
    case 'percent':
      return isNaN(item) ? item : `${(item || 0).toFixed(2)} %`;
    default:
      return isNaN(item) ? item : Math.abs(+item) > 100 ? item : +item;
  }
};

const yAxisFormatter = (item, format) => {
  switch (format) {
    case 'currency':
      return isNaN(item) ? item : Math.abs(+item) > 1000 ? `${item / 1000}K` : +item;
      break;
    case 'percent':
      return isNaN(item) ? item : `${item}%`;
      break;
      break;
    default:
      return isNaN(item) ? item : Math.abs(+item) > 1000 ? `${item / 1000}K` : +item;
      break;
  }
};

const dateFormatter = (item, granularity, dateFormatter) => {
  if (granularity) {
    switch (granularity) {
      case 'day': {
        return moment(item).format(dateFormatter);
      }
      case 'month': {
        return moment(item).format('MMM YYYY');
      }
      case 'week': {
        return i18n.t('common.week_format', { date: moment(item).format('WW, YYYY') });
      }
      case 'year': {
        return moment(item).format('YYYY');
      }
    }
  }

  return moment(item).format('MMM YYYY');
};

const xAxisFormatter = (item) => {
  if (moment(item).isValid()) {
    return dateFormatter(item);
  } else {
    return '--';
  }
};

export {
  tooltipFormatter,
  yAxisFormatter,
  xAxisFormatter,
  dateFormatter,
  CHART_COLORS,
  DEFAULT_CURRENCY,
};
